import type { RenderCustomFieldProps } from "../../../../../types";
import RenderGLCalendarPostingMonthActiveLabels from "../gl-calendar/RenderGLCalendarPostingMonthActiveLabels";

// To add a new custom field component: implement it in its own file
// (see RenderGLCalendarPostingMonthActiveLabels.tsx for the shape), then
// add one entry here. No changes needed in DynamicAdvancedFieldRenderer.
export const CUSTOM_COMPONENTS: Record<
  string,
  React.ComponentType<RenderCustomFieldProps>
> = {
  is_posting_month_active: RenderGLCalendarPostingMonthActiveLabels,
};
